var map = {
	"./alphabets.json": [
		626,
		626
	],
	"./animals.json": [
		63,
		63
	],
	"./colors.json": [
		870,
		870
	],
	"./gk.json": [
		444,
		444
	],
	"./math.json": [
		864,
		864
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 598;
module.exports = webpackAsyncContext;